import { SvgIcon } from '@/common/components/SvgIcon'

interface PropsType {
  url: string
}

const UpdateButton = (props: PropsType) => {
  return (
    <a href={props.url} className="group ext-button h-10 w-full min-w-30 text-sm">
      その他条件を更新
      <SvgIcon name="arrows-rotate" width={16} className="ml-1 text-blue-500 group-hover:text-[#ed2d2d]" />
    </a>
  )
}

export default UpdateButton
